import { emailConfigSchema } from './config-schema.js';

export const emailDefinition = {
  type: 'email',
  nameKey: 'nodes.email.name',
  subtitleKey: 'nodes.email.subtitle',
  modalTitleKey: 'nodes.email.title',
  icon: 'mail',
  color: '#3B82F6',
  colorGradient: 'linear-gradient(135deg, #60A5FA, #2563EB)',
  category: 'allApps',
  schema: emailConfigSchema
};
